<template>
  <div class="article-edit">
    <el-card class="edit-container">
      <!-- 顶部操作栏 -->
      <div class="header">
        <el-form :inline="true" :model="articleForm" class="form-content">
          <el-form-item label="文章名称" required>
            <el-input
              v-model="articleForm.article_name"
              placeholder="请输入文章名称"
              style="width: 300px"
            />
          </el-form-item>
          <el-form-item label="文章类型" required>
            <el-select v-model="articleForm.article_type" placeholder="请选择文章类型">
              <el-option
                v-for="item in articleTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="标签">
            <el-tag
              v-for="tag in tags"
              :key="tag"
              class="mx-1"
              closable
              @close="handleClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              v-if="inputVisible"
              ref="InputRef"
              v-model="inputValue"
              class="ml-1 w-20"
              size="small"
              @keyup.enter="handleInputConfirm"
              @blur="handleInputConfirm"
            />
            <el-button
              v-else
              class="button-new-tag ml-1"
              size="small"
              @click="showInput"
            >
              + 新增标签
            </el-button>
          </el-form-item>
          <el-form-item class="action-buttons">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleSave">保存</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 原生左右布局 -->
      <div class="editor-container">
        <mavon-editor
          ref="md"
          v-model="articleForm.article_info"
          :toolbars="toolbars"
          :box-shadow="false"
          :subfield="true"
          :defaultOpen="'preview'"
          :toolbarsFlag="true"
          :navigation="true"
          :placeholder="'开始编写文章...'"
          :ishljs="true"
          :codeStyle="'github'"
          :style="{height: '100%'}"
          @save="handleSave"
          @imgAdd="$imgAdd"
          @imgDel="$imgDel"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

export default {
  name: 'ArticleEdit',
  components: {
    mavonEditor
  },
  data() {
    return {
      // 文章类型选项
      articleTypes: [
        { value: 'OI', label: 'OI' },
        { value: '题解', label: '题解' },
        { value: '游记', label: '游记' },
        { value: '生活', label: '生活' },
        { value: '学习', label: '学习' },
        { value: '科技', label: '科技' },
        { value: '情感', label: '情感' },
        { value: '游戏', label: '游戏' },
        { value: '随笔', label: '随笔' },
        { value: '其他', label: '其他' }
      ],
      // 表单数据
      articleForm: {
        article_type: '',
        article_name: '',
        article_info: '',
        article_tag: ''
      },
      // 标签相关
      inputVisible: false,
      inputValue: '',
      tags: [],
      // 编辑器配置
      toolbars: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: true,
        superscript: true,
        subscript: true,
        quote: true,
        ol: true,
        ul: true,
        link: true,
        imagelink: true,
        code: true,
        table: true,
        fullscreen: true,
        readmodel: true,
        htmlcode: false,
        help: true,
        undo: true,
        redo: true,
        trash: true,
        save: true,
        navigation: true,
        alignleft: true,
        aligncenter: true,
        alignright: true,
        subfield: true,
        preview: true
      },
      // base64 图片映射
      base64Map: {},
      base64Index: 0
    }
  },
  mounted() {
    // 保存原始 $render 方法
    const mdInstance = this.$refs.md
    const originalRender = mdInstance.$render.bind(mdInstance)
    const base64Map = this.base64Map

    // 拦截 $render：在 markdown-it 渲染前，将占位符还原为真实 base64
    // 关键架构：
    // - d_value（编辑区 markdown 源文）含 __IMG_N__ 占位符 → textarea 显示干净
    // - d_render（预览区 HTML）含真实 base64 data URL → 图片正常显示
    mdInstance.$render = function (src, func) {
      let processed = src
      Object.keys(base64Map).forEach(key => {
        processed = processed.replace(key, base64Map[key])
      })
      originalRender(processed, func)
    }
  },
  created() {
    if (this.$route.params.articleCode) {
      this.getDetail(this.$route.params.articleCode)
    }
  },
  methods: {
    // 显示标签输入框
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.InputRef.focus()
      })
    },
    // 处理标签输入确认
    handleInputConfirm() {
      if (this.inputValue) {
        this.tags.push(this.inputValue)
        this.articleForm.article_tag = this.tags.join(',')
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 处理标签删除
    handleClose(tag) {
      this.tags = this.tags.filter(t => t !== tag)
      this.articleForm.article_tag = this.tags.join(',')
    },
    // 获取文章详情
    async getDetail(articleCode) {
      try {
        const response = await this.$http.get(`/api/articles/${articleCode}`)
        if (response.code === 200) {
          const article = response.data
          // 对已存在的 base64 图片也做占位符替换，保持编辑区干净
          const processedInfo = this.replaceBase64WithPlaceholders(article.article_info || '')
          this.articleForm = {
            article_type: article.article_type,
            article_name: article.article_name,
            article_info: processedInfo,
            article_tag: article.article_tag
          }
          this.tags = article.article_tag ? article.article_tag.split(',') : []
        } else {
          this.$message.error(response.message || '获取文章详情失败')
        }
      } catch (error) {
        console.error('获取文章详情失败：', error)
        this.$message.error(error.message || '获取文章详情失败')
      }
    },
    // 将 content 中的 base64 data URL 图片替换为占位符，保持编辑区清洁
    replaceBase64WithPlaceholders(content) {
      // 匹配 markdown 图片语法中的 base64 data URL：![...](data:image/...;base64,...)
      const regex = /!\[([^\]]*)\]\((data:image\/[^;]+;base64,[^)]+)\)/g
      return content.replace(regex, (match, alt, base64Url) => {
        const placeholder = `__IMG_${this.base64Index}__`
        this.base64Map[placeholder] = base64Url
        this.base64Index++
        return `![${alt}](${placeholder})`
      })
    },
    // 保存文章
    async handleSave() {
      if (!this.articleForm.article_type) {
        this.$message.warning('请选择文章类型')
        return
      }
      if (!this.articleForm.article_name) {
        this.$message.warning('请输入文章名称')
        return
      }
      if (!this.articleForm.article_info) {
        this.$message.warning('请输入文章内容')
        return
      }

      // 保存前将占位符还原为真实 base64，确保入库数据完整
      const saveData = {
        ...this.articleForm,
        article_info: this.articleForm.article_info
      }
      Object.keys(this.base64Map).forEach(key => {
        saveData.article_info = saveData.article_info.replace(key, this.base64Map[key])
      })

      try {
        if (this.$route.params.articleCode) {
          await this.$http.put(`/api/articles/${this.$route.params.articleCode}`, saveData)
          this.$message.success('更新成功')
        } else {
          await this.$http.post('/api/articles', saveData)
          this.$message.success('创建成功')
        }
        this.$router.push('/article')
      } catch (error) {
        console.error('保存文章失败：', error)
        this.$message.error('保存文章失败')
      }
    },
    // 取消编辑
    handleCancel() {
      this.$router.push('/article')
    },
    // 处理图片上传
    $imgAdd(pos, file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const base64 = reader.result
        const placeholder = `__IMG_${this.base64Index}__`
        this.base64Map[placeholder] = base64
        this.base64Index++
        this.$nextTick(() => {
          // 找到 d_value 中 mavon-editor 刚插入的图片 URL（pos 对应的内容），替换为占位符
          const mdInstance = this.$refs.md
          // 构造匹配 d_value 中该 pos 图片的正则：![任意文本](pos)
          const escapedPos = String(pos).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
          const regex = new RegExp(`!\\[[^\\]\\[]*\\]\\((${escapedPos})\\)`)
          if (regex.test(mdInstance.d_value)) {
            mdInstance.d_value = mdInstance.d_value.replace(regex, `![image](${placeholder})`)
            // iRender() 会触发 $render → 预览区因 $render override 替换后正确显示图片
            mdInstance.iRender()
          }
        })
      }
      reader.onerror = () => {
        this.$message.error('图片上传失败')
      }
    },
    // 处理图片删除
    $imgDel(pos) {
      console.log('删除图片:', pos)
    }
  }
}
</script>

<style scoped>
.article-edit {
  height: calc(100vh - 84px);
  padding: 20px;
  box-sizing: border-box;
}

.edit-container {
  height: 100%;
}

.edit-container :deep(.el-card__body) {
  height: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.header {
  padding: 12px 20px;
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
}

.form-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 0;
}

.form-content :deep(.el-form-item) {
  margin-bottom: 0;
  margin-right: 16px;
}

.form-content :deep(.el-form-item__content) {
  margin-left: 8px !important;
}

.action-buttons {
  margin-left: auto !important;
  margin-right: 0 !important;
}

.editor-container {
  flex: 1;
  padding: 20px;
  overflow: hidden;
}

:deep(.v-note-wrapper) {
  z-index: 1;
  min-height: 100% !important;
}

:deep(.v-note-op) {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
}

:deep(.v-note-panel) {
  display: flex !important;
}

:deep(.v-note-edit-wrapper) {
  flex: 1 !important;
  min-width: 50% !important;
  padding: 20px;
  border-right: 1px solid #ddd;
}

:deep(.v-note-show) {
  flex: 1 !important;
  min-width: 50% !important;
  padding: 20px;
}

:deep(.v-note-edit) {
  height: 100% !important;
}

:deep(.v-note-show-content) {
  padding: 0 !important;
  background: #fff;
}

:deep(.v-note-show-content img) {
  max-width: 100% !important;
  height: auto !important;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
